import { createAlchemyWeb3 } from '@alch/alchemy-web3';
export const NFTCONTRACT = "0xCbFE479cE22dfF8f63F0FAE9027F4fc6dD217b3b";
export const STAKINGCONTRACT = "0x7FFC088912AC7B00A3Dd155526C6EfC9FcAd6737";
export const polygonscanapi = "https://api.polygonscan.com/api";
export const moralisapi = "https://deep-index.moralis.io/api/v2/";
export const nftpng = "https://storage.googleapis.com/amg_nft_staking/";
export const Web3Alc = createAlchemyWeb3("https://polygon-mainnet.g.alchemy.com/v2/eXdsc7gelDMFDXjE8frz6x8THX9jff7w");